/**
 * The three Ionic components the app uses, registered one by one. Importing
 * them individually (rather than the whole @ionic/react package, which pulls
 * in every component) keeps the first load small enough for slow networks
 * (E6-S9).
 */
import { initialize } from '@ionic/core/components';
import { defineCustomElement as defineApp } from '@ionic/core/components/ion-app.js';
import { defineCustomElement as defineContent } from '@ionic/core/components/ion-content.js';
import { createElement, type ReactNode } from 'react';

initialize({ mode: 'md', animated: false });
defineApp();
defineContent();

export function IonApp({ children }: { children: ReactNode }) {
  return createElement('ion-app', null, children);
}

/** A full-screen page. Ionic lays these out to fill the app and respect safe areas. */
export function IonPage({ children }: { children: ReactNode }) {
  return <div className="ion-page">{children}</div>;
}

/** The scrolling area of a page; handles overscroll and the on-screen keyboard on phones. */
export function IonContent({ children }: { children: ReactNode }) {
  return createElement('ion-content', null, children);
}
